const en = {
  home: {
    title: "AllChinaBuySpreadsheet",
    subtitle: "The Most Updated China Product Sourcing Spreadsheet",
  },
};

export default en;